import { getUserMail } from "../../services/util/getUserMail";
import { axiosOption } from "../axios";
// let userObj:any = {'email_id' : getUserMail()}


export function getStartEndDateIO(months: any, asset: any, type: any) {
    let userObj: any = { 'email_id': getUserMail() }
    return axiosOption.post(`/intraday/get_startDate_endDate`, { "month": months, "asset": asset, "type": type, "username": userObj?.email_id })
        .then((res: any) => {
            return res;
        }).catch((e: any) => console.log("ERROR:", e)

        )
}
    
export function getHistoricalPlPercentageIO(startDate: any, endDate: any, version: any, tradetype: any, asset_type: any, filterDropdownVersion: any) {
    let userObj: any = { 'email_id': getUserMail() }
    let optionObj: any = {
        startDate: startDate,
        endDate: endDate,
        version: version,
        tradetype: tradetype,
        asset: asset_type,
        filterDropdownVersion: filterDropdownVersion,
        username: userObj?.email_id
    }
    return axiosOption.post(`/options/get_pl_percent`, optionObj)
        .then((res: any) => {
            return res.data;
        }).catch((err: any) => console.log(err))
}

export function getHistoricalTradesIO(startDate: any, endDate: any, version: any, tradetype: any, asset_type: any, filterDropdownVersion: any) {

    let userObj: any = { 'email_id': getUserMail() }
    let optionObj: any = {
        startDate: startDate,
        endDate: endDate,
        version: version,
        tradetype: tradetype,
        asset: asset_type,
        filterDropdownVersion: filterDropdownVersion,
        username: userObj?.email_id
    }
    return axiosOption.post(`/options/get_trades`, optionObj)
        .then((res: any) => {
            return res.data;
        }).catch((err: any) => {
            console.log(err)
            return []
        }
        )
}


export function getHistoricalCallsIO(startDate:any,endDate:any, version: any,tradetype:any,asset_type:any, filterDropdownVersion:any){
    let userObj:any = {'email_id' : getUserMail()}
    let optionObj:any = {
            startDate: startDate,
            endDate: endDate,
            version  : version,
            tradetype: tradetype,
            asset    : asset_type,
            filterDropdownVersion:filterDropdownVersion, 
            username : userObj?.email_id
    }
    return axiosOption.post(`/options/get_calls`,optionObj)
        .then((res:any) => {
            return res.data;
    }).catch((err:any) => console.log(err))
}

export function getHistoricalSRIO(startDate:any,endDate:any, version: any ,tradetype:any,asset_type:any, filterDropdownVersion:any)
{
    let userObj:any = {'email_id' : getUserMail()}
    let tradeType:any = version === 'all' ? 'short' : 'Total'
    let optionObj:any = {
            startDate: startDate,
            endDate:endDate,
            version  : version,
            tradetype: tradeType,
            asset    : asset_type,
            filterDropdownVersion:filterDropdownVersion, 
            username : userObj?.email_id
    }
    return axiosOption.post(`/options/get_sr`,optionObj)
        .then((res:any) => {
            return res.data;
    }).catch((err:any) => console.log(err))
}

export function getHistoricalPlIO(startDate: any, endDate: any, version: any, tradetype: any, asset_type: any, filterDropdownVersion: any) {
    let userObj:any = {'email_id' : getUserMail()}
    let optionObj: any = {
        startDate: startDate,
        endDate: endDate,
        version: version,
        tradetype: tradetype,
        asset: asset_type,
        filterDropdownVersion: filterDropdownVersion,
        username: userObj?.email_id
    }
    return axiosOption.post(`/options/get_pl`, optionObj)
        .then((res: any) => {

            return res.data;
        }).catch((err: any) => console.log(err))
}

export function getTargetSlIO(date: any, asset: any, id: any, version: any, tradetype: any) {

    let optionObj: any = {
        "date": date,
        "asset": asset,
        "id": id,
        "version": version,
        "trade_type": tradetype
    }
    return axiosOption.post(`/options/get_target_stoploss`, optionObj)
        .then((res: any) => {
            return res.data;
        }).catch((err: any) => console.log(err))
}

export function getMtmDrawdownIO(date: any, asset: any, id: any, version: any) {
    let optionObj: any = {
        "date": date,
        "asset": asset,
        "id": id,
        "version": version
    }
    return axiosOption.post(`/options/get_m2m_drawdown`, optionObj)
        .then((res: any) => {
            return res?.data;
        }).catch((err: any) => console.log(err))
}

export function getParameterIO(id: any, asset: any, date: any, version: any) {
    let userObj:any = {'email_id' : getUserMail()}
    let optionObj: any = {
        id: id,
        asset: asset,
        date: date,
        version: version, 
        username : userObj?.email_id
    }
    return axiosOption.post(`/options/get_parameter`, optionObj)
        .then((res: any) => {
            return res?.data;
        }).catch((err: any) => console.log(err))
}